import { createQueryHook } from "../factory";

export const dashboardSummaryKeys = {
  all: ["dashboardSummary"] as const,
  details: () => [...dashboardSummaryKeys.all, "detail"] as const,
  detail: <T>(input: T) => [...dashboardSummaryKeys.details(), input] as const,
};

const providerClaimsMetricsKeys = {
  all: ["providerClaimsMetrics"] as const,
  list: () => [...providerClaimsMetricsKeys.all, "list"] as const,
};

const providerDashboardSummaryKeys = {
  all: ["providerDashboardSummary"] as const,
  detail: () => [...providerDashboardSummaryKeys.all, "detail"] as const,
};

export const dashboard = {
  getDashboardSummary: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.dashboard.getDashboardSummary,
    queryKeyFn: dashboardSummaryKeys.detail,
  }),
  getProviderClaimsMetrics: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.dashboard.getProviderClaimsMetrics,
    queryKeyFn: providerClaimsMetricsKeys.list,
  }),
  getProviderDashboardSummary: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.dashboard.getProviderDashboardSummary,
    queryKeyFn: providerDashboardSummaryKeys.detail,
  }),
};
